import { render, staticRenderFns } from "./IconNarrowRight.vue?vue&type=template&id=5eb65ff9&"
import script from "./IconNarrowRight.vue?vue&type=script&lang=js&"
export * from "./IconNarrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports